<template>
  <div class="page">
    <div class="page-container">
      <header class="page-header">
        <b-icon
          :icon="headerIcon"
          size="is-small"
          class="page-header-icon"
        ></b-icon>
        <h1 class="page-header-title">
          {{ title }}
        </h1>
      </header>
      <section class="page-main">
        <b-loading :active.sync="isLoading" :is-full-page="false"></b-loading>
        <template v-if="!isLoading">
          <div v-if="$slots.error" class="page-error">
            <slot name="error"></slot>
          </div>
          <template v-if="$slots.main">
            <div class="page-logo">
              <img class="page-logo-img" :src="logo" />
            </div>
            <div class="page-content">
              <slot name="main"></slot>
            </div>
          </template>
        </template>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    headerIcon: {
      type: String,
      required: true
    },
    logo: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped lang="scss">
@import "bulma/sass/utilities/mixins.sass";
@import "@/scss/colors";

$logo-width-tablet: 40%;
$logo-width-desktop: 50%;

.page {
  @include tablet {
    align-items: center;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    height: 100vh;
    justify-content: center;
    min-height: 100vh;
    padding: 30px;
  }
  &-container {
    height: 100%;
    width: 100%;
    @include tablet {
      display: flex;
      flex-direction: column;
      height: 100%;
      max-width: 1080px;
    }
  }
  &-header {
    align-items: center;
    background: linear-gradient(
        270deg,
        rgba(34, 211, 154, 0.27) 15.51%,
        rgba(40, 88, 196, 0.27) 39.58%
      ),
      $primary;
    color: $light;
    display: flex;
    padding: 20px;
    @include tablet {
      padding: 20px 30px;
    }
    &-icon {
      font-size: 24px;
      margin-top: 2px;
      @include tablet {
        font-size: 30px;
      }
    }
    &-title {
      font-size: 18px;
      line-height: 1.2;
      margin-left: 15px;
      @include tablet {
        font-size: 24px;
      }
    }
  }
  &-main {
    background: $light;
    min-height: 300px;
    position: relative;
    @include tablet {
      display: flex;
      height: 100%;
    }
  }
  &-error {
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    height: 100%;
    justify-content: center;
    line-height: 1.8;
    min-height: 300px;
    padding: 30px;
    text-align: center;
    width: 100%;
  }
  &-logo {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 150px;
    justify-content: center;
    padding: 30px;
    width: 100%;
    @include tablet {
      height: 100%;
      left: 0;
      pointer-events: none; // Disable pointer events to be able to scroll content on the left
      position: absolute;
      top: 0;
      width: $logo-width-tablet;
    }
    @include desktop {
      width: $logo-width-desktop;
    }
    &-img {
      max-height: 150px;
      max-width: 300px;
    }
  }
  &-content {
    @include tablet {
      height: 100%;
      overflow: auto;
      padding: 20px 20px 20px $logo-width-tablet;
      width: 100%;
    }
    @include desktop {
      padding-left: $logo-width-desktop;
    }
  }
}
</style>
